import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/payroll-engine/payroll-structures/$structureId/structure',
      params,
    });
  },
});
